/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

/* global lng, CONTENT_TARGET, toggleMDLDrawer, snackbar */

function FormViewer() {
  if (!this instanceof FormViewer) return new FormViewer();

  const that = this;
  const contactmail = undefined;
  const optins = [];
  // -- attributes --
  //min length of signature
  const SIGN_REQUIRED_LENGTH = 35; //Sync this with CustomerService.js
  // will be filled after class init
  this.streetRecords = null;
  this.deliveryAreas = null;

  /**
   * @type {Object} object that will passed to server when form is finished
   */
  this.formData = {
    meta: {},
    data: [],
  };
  /**
   * @type Element
   */
  this.node;

  /**
   * @type FormImageProvider
   */
  this.formImageProvider;

  this.node = document.createElement("table");
  this.node.classList.add("form-viewer");
  this.node.classList.add("mdl-data-table");
  this.node.classList.add("mdl-js-data-table");

  // -- add fullscreen button ---

  // -- functions --
  this.loadJson = loadJson;
  this.getJSON = getJSON;
  this.clear = clear;
  this.isDirty = isDirty;
  this.loadData = loadData;

  // -- callbacks --
  /**
   * After user click on the submit button, this callback will be called with data as json.
   * @param {string} data
   * @returns {undefined}
   */
  this.onsubmit = function (data) {
    console.warn("overwrite onsubmit()");
  };
  /**
   * After user click on the onChooseBlueprint button, this callback will be called with data as json.
   * @param {string} data
   * @returns {undefined}
   */
  this.onChooseBlueprint = function (data) {
    console.warn("overwrite onChooseBlueprint()");
  };

  /**
   * This function is called if loading of the form viewer begins.
   */
  this.onFormViewerLoadingBegins = function () {
    console.warn("overwrite onFormViewerLoadingEnds()");
  };
  /**
   * This function is called if loading of the form viewer ends.
   */
  this.onFormViewerLoadingEnds = function () {
    console.warn("overwrite onFormViewerLoadingEnds()");
  };

  function loadJson(json) {
    // loading begins
    that.onFormViewerLoadingBegins();
    json = JSON.parse(json);

    let i = 0;
    const len = json.length;
    for (; i < len; i++) {
      const item = json[i];
      const input = genInput(item);
      that.node.appendChild(input);
    }

    //submit
    that.node.appendChild(
      genInput({
        type: "submit",
        meta: { name: "" },
      })
    );

    // loading ends
    that.onFormViewerLoadingEnds();
  }

  function genInput(data) {
    const tr = document.createElement("tr");
    tr.classList.add("input");
    tr.classList.add("input-" + data.type);
    tr.data = { name: data.meta.name };

    switch (data.type) {
      case "sign":
        createHeaderRow(data);
        genSign(data);
        break;
      case "address":
        createHeaderRow(data);
        genAddress(that, tr, data);
        break;
      case "tel":
        createHeaderRow(data);
        genTel(data);
        break;
      case "multichoice":
        createHeaderRow(data);
        genMultiChoice(data);
        break;
      case "raffle":
        createHeaderRow(data);
        genRaffle(data, that);
        break;
      case "default":
        createHeaderRow(data);
        genDefault(data);
        break;
      case "text":
        createHeaderRow(data);
        genText(data);
        break;
      case "textArea":
        createHeaderRow(data);
        genTextArea(data);
        break;
      case "image":
        genImage(data);
        break;
      case "submit":
        genSubmit();
        break;
      case "hr":
        genHr(data);
        break;
      default:
        console.error("Type " + data.type + " not implemented");
    }

    return tr;

    //adds the label row if necessary
    function createHeaderRow(data) {
      if (data.meta.label != "") {
        const trLabel = document.createElement("tr");
        const tdLabel = document.createElement("td");
        const label = document.createElement("label");
        label.textContent = data.meta.label;
        tdLabel.classList.add("label");
        tdLabel.appendChild(label);
        trLabel.appendChild(tdLabel);
        that.node.appendChild(trLabel);
      }
    }

    function genHr(data) {
      const hr = document.createElement("hr");
      hr.setAttribute("style", `border-top:${data.data.height}px solid #ccc`);
      tr.appendChild(hr);
    }

    function genImage(data) {
      const td = document.createElement("td");
      tr.appendChild(td);
      // td.colSpan = 2;

      const img = document.createElement("img");
      td.appendChild(img);

      const imageProvider = that.formImageProvider;

      // call event function
      if (data.meta.partner) {
        imageProvider.get("partner_logo").then((url) => (img.src = url));
      } else {
        imageProvider
          .get(data.data.image, true)
          .catch(() => imageProvider.get(data.meta.name))
          .then((url) => (img.src = url));
      }

      //no getData()
    }

    function genRaffle(data, that) {
      const td = document.createElement("td");
      td.classList.add("raffle");

      for (let d in data.data) {
        if (
          d.indexOf("text") !== 0 ||
          d.indexOf("_disableAddressCheckbox") !== -1
        ) {
          // `text${i}`
          continue;
        }
        const div = document.createElement("div");
        div.innerHTML = `
                    <div class="text-container">
                        <div class="checkbox-wrapper">
                            <label>
                                <input type="checkbox" name="${data.meta.name}">
                                <div class="checkbox-img"></div>
                            </label>
                        </div>
                    <div class="checkbox-text">${data.data[d]}</div>`;
        td.appendChild(div);

        const input = div.getElementsByTagName("input")[0];

        if (data.meta.required) {
          input.classList.add("isRequired");
          input.setCustomValidity(lng.get("form-input-raffle-required"));
        }

        let hideAddressCheckbox;
        switch (data.data[d + "_disableAddressCheckbox"]) {
          case true:
            hideAddressCheckbox = true;
            break;
          case false:
            hideAddressCheckbox = false;
            break;
          case undefined: // compatibility mode
            hideAddressCheckbox = d === "text2";
        }

        input.addEventListener("change", function (e) {
          const checked = e.target.checked;

          if (data.meta.required) {
            const allCheckboxes = Array.from(
              td.querySelectorAll(`input[name="${data.meta.name}"]`)
            );
            if (!allCheckboxes.some((input) => input.checked)) {
              allCheckboxes.forEach((input) =>
                input.setCustomValidity(lng.get("form-input-raffle-required"))
              );
            } else {
              allCheckboxes.forEach((input) => input.setCustomValidity(""));
              //add for validation (idk wtf this does)
              Array.from(that.node.querySelectorAll(".text-container")).forEach(
                (textContainer) => textContainer.classList.remove("not-valid")
              );
            }
          }

          if (!data.meta.multiple) {
            Array.from(
              td.querySelectorAll(`input[name="${data.meta.name}"]`)
            ).forEach((input) => {
              if (e.target !== input) input.checked = false;
            });
          }

          Array.from(that.node.getElementsByClassName("input-address")).forEach(
            (addressInput) => {
              const checkboxContainer =
                addressInput.getElementsByClassName("checkbox-container")[0];

              if (!checkboxContainer) {
                return;
              }

              const checkboxes = checkboxContainer.querySelectorAll(
                "input[type=checkbox]"
              );
              if (!checkboxes) {
                // no address checkboxes found
                return;
              }

              if (data.meta.multiple && hideAddressCheckbox) {
                if (checked) {
                  hideAddress();
                } else {
                  showAddress();
                }
              } else if (!data.meta.multiple) {
                if (hideAddressCheckbox && checked) {
                  hideAddress();
                } else {
                  showAddress();
                }
              }

              function hideAddress() {
                checkboxContainer.classList.add("hidden");
                checkboxContainer.classList.remove("valid");
                checkboxContainer.classList.remove("not-valid");
                checkboxes.forEach((checkbox) => {
                  checkbox.setCustomValidity("");
                  checkbox.checked = false;
                });
              }

              function showAddress() {
                checkboxContainer.classList.remove("hidden");
                const checkboxArray = Array.from(checkboxes);
                if (!checkboxArray.some((checkbox) => checkbox.checked)) {
                  checkboxes.forEach((checkbox) =>
                    checkbox.setCustomValidity(
                      "Bitte wählen Sie eines der Felder aus."
                    )
                  );
                }
              }
            }
          );
        });
      }

      tr.appendChild(td);

      tr.getData = function () {
        const result = {
          name: data.meta.name,
          data: [],
        };

        const texts = td.querySelectorAll(".checkbox-text");
        Array.from(td.querySelectorAll("input[type=checkbox]")).forEach(
          (input, i) => {
            if (input.checked) result.data.push(texts[i].innerHTML);
          }
        );
        return result;
      };
    }

    function genMultiChoice(data) {
      const td = document.createElement("td");
      td.classList.add("multichoice");
      tr.appendChild(td);

      for (let i = 0, len = data.data.length; i < len; i++) {
        const elemDiv = document.createElement("div");
        td.appendChild(elemDiv);
        elemDiv.classList.add(`multichoice-elem`);
        const input = data.data[i];
        const div = document.createElement("div");
        const radioOrCheckbox = document.createElement("input");
        radioOrCheckbox.type = !data.meta.multic ? "radio" : "checkbox";
        radioOrCheckbox.id = (data.meta.name + input.label).replace(/\s/g, "");
        radioOrCheckbox.name = data.meta.name;
        div.classList.add(`${radioOrCheckbox.type}-wrapper`);
        div.innerHTML = `
                            <label>
                                <div class="${radioOrCheckbox.type}-img"></div>
                            </label>`;

        // render stuff ?
        const inputWrapper = div.getElementsByTagName(`label`)[0];
        inputWrapper.insertAdjacentElement("afterbegin", radioOrCheckbox);
        elemDiv.appendChild(div);
        const label = document.createElement("label");
        elemDiv.appendChild(label);
        label.htmlFor = radioOrCheckbox.id;
        label.innerHTML = input.label;

        // omg .... input check means if a radio or checkbox has an^ input field
        if (input.check) {
          // "Auswahlelement" has an input field behind
          elemDiv.classList.add("multichoice-elem-big");
          const textinput = document.createElement("input");
          elemDiv.appendChild(textinput);
          textinput.type = "text";
          const delbutton = document.createElement("i");
          delbutton.innerHTML = "clear";
          delbutton.classList.add("material-icons");
          delbutton.classList.add("clearinput");
          delbutton.addEventListener("click", function () {
            let delButtonInput =
              this.parentElement.querySelector("input[type=text]");
            delButtonInput.value = "";
            // trigger checkbox/radio input validation
            const input = elemDiv.querySelector('input[type="text"]');
            input.dispatchEvent(new Event("input"));
          });
          elemDiv.appendChild(delbutton);
        }

        // -- VALIDATION
        if (data.meta.required) {
          radioOrCheckbox.required = true;
        }
        radioOrCheckbox.addEventListener("change", () => {
          // -- GENERAL HANDLING
          // if at least on options is checked, remove invalid status, otherwise add invalid status
          const inputs = td.querySelectorAll(
            "input[type=checkbox],input[type=radio]"
          );
          if (data.meta.required) {
            if (Array.from(inputs).some((input) => input.checked)) {
              // check if at least on is checked
              inputs.forEach((elem) => {
                if (!elem.checked) {
                  elem.required = false;
                }
                elem.setCustomValidity("");
                const inputWrapper = closest(elem, ".multichoice-elem");
                inputWrapper.classList.remove("not-valid");
              });
            } else {
              inputs.forEach((elem) => {
                elem.required = true;
                elem.setCustomValidity(
                  "Bitte wählen Sie mindestens eine Auswahl aus"
                );
                const inputWrapper = closest(elem, ".multichoice-elem");
                inputWrapper.classList.add("not-valid");
              });
            }
          }
          // input handling
          const textInput = closest(
            radioOrCheckbox,
            ".multichoice-elem"
          ).querySelector('input[type="text"]');
          if (textInput) {
            // this if block is important if radio/checkbox change event is fired
            if (
              textInput &&
              radioOrCheckbox.checked &&
              textInput.value === ""
            ) {
              textInput.setCustomValidity(
                "Bitte tragen Sie eine Antwortmöglichkeit im Feld ein"
              );
            } else {
              textInput.setCustomValidity("");
            }
            // trigger validation for each text input
            const textInputs = closest(
              radioOrCheckbox,
              ".input-multichoice"
            ).querySelectorAll('input[type="text"]');
            textInputs.forEach((input) =>
              input.dispatchEvent(new Event("input"))
            );

            // this if block is important if input values changes
            textInput.addEventListener("input", function () {
              if (
                textInput &&
                radioOrCheckbox.checked &&
                textInput.value === ""
              ) {
                textInput.setCustomValidity(
                  "Bitte tragen Sie eine Antwortmöglichkeit im Feld ein"
                );
              } else {
                textInput.setCustomValidity("");
              }
            });
          }
        });
      }

      // render radio reset button
      if (!data.meta.multic) {
        // create container (necessary for correct spacing
        const outerContainer = document.createElement("div");
        outerContainer.classList.add("multichoice-elem");
        // appen container to formviewer element
        td.append(outerContainer);

        const innerContainer = document.createElement("div");
        innerContainer.classList.add("radio-wrapper");
        outerContainer.append(innerContainer);

        const resetButton = document.createElement("button");
        resetButton.innerHTML = '<i class="material-icons">close</i>';
        resetButton.classList.add(
          "mdl-button",
          "mdl-js-button",
          "mdl-button--fab",
          "mdl-button--mini-fab",
          "mdl-button--colored",
          "clear",
          "reset-button"
        );
        resetButton.addEventListener("click", () => {
          const radioButtons = td.querySelectorAll('input[type="radio"]');
          radioButtons.forEach((radioButton) => {
            if (data.meta.required) {
              radioButton.required = true;
            }
            radioButton.checked = false;
          });

          // -- VALIDATION
          // mark each item as invalid if multi choice elem is required and resetted
          if (data.meta.required) {
            td.querySelectorAll(".multichoice-elem:not(:last-child)").forEach(
              (elem) => elem.classList.add("not-valid")
            );
          }
          // reset each radio input
          td.querySelectorAll('input[type="text"]').forEach((input) =>
            input.setCustomValidity("")
          );
        });
        innerContainer.append(resetButton);
      }

      tr.getData = function () {
        const result = {
          name: data.meta.name,
          data: [],
        };

        const inputs = Array.from(td.children);
        inputs.map((input) => {
          const children = Array.from(input.children);
          const inp = children[0].querySelector("input");
          if (inp && inp.checked) {
            let datas = children[1].innerHTML;
            if (children.length > 2) {
              datas = datas + "-" + children[2].value;
            }
            result.data.push({ name: "", val: datas });
          }
        });
        return result;
      };
    }

    function genDefault(data) {
      const td = document.createElement("td");
      tr.appendChild(td);

      let i = 0;
      const len = data.data.length;
      for (; i < len; i++) {
        var input = data.data[i];

        //select treatment
        if (input.type === "select") {
          const selectNode = document.createElement("select");
          selectNode.name = input.name;

          if (input.label) {
            var option = document.createElement("option");
            option.disabled = true;
            option.selected = true;
            option.hidden = true;
            option.value = "";
            option.textContent = input.label;
            selectNode.appendChild(option);
            selectNode.classList.add("not-chosen");
          }
          const options = input.options.split(";");
          options.map((o) => {
            const opt = o.split(/{|}/);
            const option = document.createElement("option");
            option.textContent = opt[0];
            if (opt.length > 1) option.value = opt[1];
            else option.value = opt[0];
            selectNode.appendChild(option);
          });
          if (input.emptySelect) {
            selectNode.required = true;
            //selectNode.required = true;
            selectNode.emptySelect = input.emptySelect;
            if (selectNode.value === "") {
              selectNode.setCustomValidity("Bitte wählen sie einen Wert aus.");
            }
            selectNode.classList.add("selectreqired");
            selectNode.addEventListener("change", function () {
              this.classList.remove("not-chosen");
              this.classList.remove("selectreqired");
              this.classList.remove("selectinvalid");
              this.classList.remove("selectvalid");
              if (this.value === "") {
                this.classList.add("selectinvalid");
                this.setCustomValidity("Bitte wählen sie einen Wert aus.");
              } else {
                this.classList.add("selectvalid");
                this.setCustomValidity("");
              }
            });
          } else {
            selectNode.addEventListener("change", function () {
              this.classList.remove("not-chosen");
            });
          }

          td.appendChild(selectNode);
        } else {
          let isdate = false;
          // input treatment
          const inputNode = document.createElement("input");
          inputNode.type = input.type;
          inputNode.name = input.name;

          // works sometimes ...
          inputNode.autocomplete = "off";
          inputNode.autocorrect = "off";
          //inputNode.autocapitalize="off";
          inputNode.spellcheck = false;

          //--- special treatment
          if (input.type === "number") {
            inputNode.step = "any";
          }
          // -- input type date
          // change type of input after click
          if (input.type === "date") {
            isdate = true;
            inputNode.pattern = ".*";
            inputNode.type = "text";
            const dateConfig = {
              dateFormat: "d.m.Y",
              disableMobile: true,
              allowInput: true,
            };

            if (input.inDate) {
              dateConfig.minDate = moment()
                .add(input.inDate, "d")
                .format("DD.MM.YYYY");
              inputNode.minDate = dateConfig.minDate.split(".");
            } else if (input.minAge) {
              dateConfig.maxDate = moment()
                .subtract(input.minAge, "y")
                .format("DD.MM.YYYY");
              inputNode.maxDate = dateConfig.maxDate.split(".");
            } else {
              if (input.minDate) {
                dateConfig.minDate = moment(input.minDate).format("DD.MM.YYYY");
                inputNode.minDate = dateConfig.minDate.split(".");
              }
              if (input.maxDate) {
                dateConfig.maxDate = moment(input.maxDate).format("DD.MM.YYYY");
                inputNode.maxDate = dateConfig.maxDate.split(".");
              }
            }
            const fp = new Flatpickr(inputNode, dateConfig);
            inputNode.fp = fp;
            if (input.required && !input.startWeekday) {
              inputNode.required = true;
              inputNode.setCustomValidity("Bitte füllen Sie dieses Feld aus.");
              inputNode.cleared = false;
              inputNode.icleared = false;
              inputNode.addEventListener("input", function () {
                this.classList.remove("not-valid");
                this.classList.remove("valid");
                if (this.icleared) {
                  this.icleared = false;
                  this.setCustomValidity("Bitte füllen Sie dieses Feld aus.");
                } else {
                  if (
                    new RegExp(
                      "(?:0[1-9]|1[0-9]|2[0-9]|3[0-1]).(?:0[1-9]|1[0-2]).(?:19|20)[0-9]{2}"
                    ).test(this.value)
                  ) {
                    const inpDate = this.value.split(".");
                    let datenotok = 0;
                    if (this.minDate) {
                      if (
                        this.minDate[2] > inpDate[2] ||
                        (this.minDate[2] === inpDate[2] &&
                          this.minDate[1] > inpDate[1]) ||
                        (this.minDate[2] === inpDate[2] &&
                          this.minDate[1] === inpDate[1] &&
                          this.minDate[0] > inpDate[0])
                      ) {
                        this.classList.add("not-valid");
                        this.setCustomValidity(
                          "Das gewählte Datum ist zu niedrig."
                        );
                        datenotok = -1;
                      }
                    }
                    if (this.maxDate && datenotok === 0) {
                      if (
                        this.maxDate[2] < inpDate[2] ||
                        (this.maxDate[2] === inpDate[2] &&
                          this.maxDate[1] < inpDate[1]) ||
                        (this.maxDate[2] === inpDate[2] &&
                          this.maxDate[1] === inpDate[1] &&
                          this.maxDate[0] < inpDate[0])
                      ) {
                        this.classList.add("not-valid");
                        this.setCustomValidity(
                          "Das gewählte Datum ist zu hoch."
                        );
                        datenotok = 1;
                      }
                    }
                    if (datenotok === 0) {
                      this.classList.add("valid");
                      this.setCustomValidity("");
                    }
                  } else {
                    this.classList.add("not-valid");
                    this.setCustomValidity(
                      "Bitte geben sie das Datum im korrekten Format an: DD.MM.JJJJ"
                    );
                  }
                }
              });
              inputNode.addEventListener("change", function () {
                this.classList.remove("not-valid");
                this.classList.remove("valid");
                if (this.cleared) {
                  this.cleared = false;
                  this.setCustomValidity("");
                } else {
                  if (this.value === "" || this.value === null) {
                    this.setCustomValidity("");
                  } else {
                    if (
                      new RegExp(
                        "(?:0[1-9]|1[0-9]|2[0-9]|3[0-1]).(?:0[1-9]|1[0-2]).(?:19|20)[0-9]{2}"
                      ).test(this.value)
                    ) {
                      const inpDate = this.value.split(".");
                      let datenotok = 0;
                      if (this.minDate) {
                        if (
                          this.minDate[2] > inpDate[2] ||
                          (this.minDate[2] === inpDate[2] &&
                            this.minDate[1] > inpDate[1]) ||
                          (this.minDate[2] === inpDate[2] &&
                            this.minDate[1] === inpDate[1] &&
                            this.minDate[0] > inpDate[0])
                        ) {
                          this.classList.add("not-valid");
                          this.setCustomValidity(
                            "Das gewählte Datum ist zu niedrig."
                          );
                          datenotok = -1;
                        }
                      }
                      if (this.maxDate && datenotok === 0) {
                        if (
                          this.maxDate[2] < inpDate[2] ||
                          (this.maxDate[2] === inpDate[2] &&
                            this.maxDate[1] < inpDate[1]) ||
                          (this.maxDate[2] === inpDate[2] &&
                            this.maxDate[1] === inpDate[1] &&
                            this.maxDate[0] < inpDate[0])
                        ) {
                          this.classList.add("not-valid");
                          this.setCustomValidity(
                            "Das gewählte Datum ist zu hoch."
                          );
                          datenotok = 1;
                        }
                      }
                      if (datenotok === 0) {
                        this.classList.add("valid");
                        this.setCustomValidity("");
                      }
                    } else {
                      this.classList.add("not-valid");
                      this.setCustomValidity(
                        "Bitte geben sie das Datum im korrekten Format an: DD.MM.JJJJ"
                      );
                    }
                  }
                }
              });
            } else {
              inputNode.cleared = false;
              inputNode.icleared = false;

              if (input.startWeekday && input.startWeekday.length > 0) {
                input.required = true;

                moment.locale("de");

                const weekdays = [
                  "monday",
                  "tuesday",
                  "wednesday",
                  "thursday",
                  "friday",
                  "saturday",
                  "sunday",
                ];
                const weekDayToFind = weekdays.indexOf(input.startWeekday);
                const nextSunday = 6;
                const searchDate = moment();

                while (searchDate.weekday() !== nextSunday) {
                  searchDate.add(1, "day");
                }
                searchDate.add(1, "day"); // Add one day because we want to start at the next week!

                while (searchDate.weekday() !== weekDayToFind) {
                  searchDate.add(1, "day");
                }

                if (input.oneMoreWeek) {
                  // Add one more week
                  searchDate.add(7, "day");
                }

                inputNode.calculatedWeekDay = searchDate
                  .utc()
                  .format("DD.MM.YYYY");
              }

              inputNode.addEventListener("input", function () {
                this.classList.remove("not-valid");
                this.classList.remove("valid");
                if (this.icleared) {
                  this.icleared = false;
                  this.setCustomValidity("");
                } else {
                  if (
                    new RegExp(
                      "(?:0[1-9]|1[0-9]|2[0-9]|3[0-1]).(?:0[1-9]|1[0-2]).(?:19|20)[0-9]{2}"
                    ).test(this.value)
                  ) {
                    const inpDate = this.value.split(".");
                    let datenotok = 0;
                    if (this.minDate) {
                      if (
                        this.minDate[2] > inpDate[2] ||
                        (this.minDate[2] === inpDate[2] &&
                          this.minDate[1] > inpDate[1]) ||
                        (this.minDate[2] === inpDate[2] &&
                          this.minDate[1] === inpDate[1] &&
                          this.minDate[0] > inpDate[0])
                      ) {
                        this.classList.add("not-valid");
                        this.setCustomValidity(
                          "Das gewählte Datum ist zu niedrig."
                        );
                        datenotok = -1;
                      }
                    }
                    if (this.maxDate && datenotok === 0) {
                      if (
                        this.maxDate[2] < inpDate[2] ||
                        (this.maxDate[2] === inpDate[2] &&
                          this.maxDate[1] < inpDate[1]) ||
                        (this.maxDate[2] === inpDate[2] &&
                          this.maxDate[1] === inpDate[1] &&
                          this.maxDate[0] < inpDate[0])
                      ) {
                        this.classList.add("not-valid");
                        this.setCustomValidity(
                          "Das gewählte Datum ist zu hoch."
                        );
                        datenotok = 1;
                      }
                    }
                    if (datenotok === 0) {
                      this.classList.add("valid");
                      this.setCustomValidity("");
                    }
                  } else {
                    this.classList.add("not-valid");
                    this.setCustomValidity(
                      "Bitte geben sie das Datum im korrekten Format an: DD.MM.JJJJ"
                    );
                  }
                }
              });
              inputNode.addEventListener("change", function () {
                this.classList.remove("not-valid");
                this.classList.remove("valid");
                if (this.cleared) {
                  this.cleared = false;
                  this.setCustomValidity("Bitte füllen Sie dieses Feld aus.");
                } else {
                  if (this.value === "" || this.value === null) {
                    this.classList.add("not-valid");
                    this.setCustomValidity("Bitte füllen Sie dieses Feld aus.");
                  } else {
                    if (
                      new RegExp(
                        "(?:0[1-9]|1[0-9]|2[0-9]|3[0-1]).(?:0[1-9]|1[0-2]).(?:19|20)[0-9]{2}"
                      ).test(this.value)
                    ) {
                      const inpDate = this.value.split(".");
                      let datenotok = 0;
                      if (this.minDate) {
                        if (
                          this.minDate[2] > inpDate[2] ||
                          (this.minDate[2] === inpDate[2] &&
                            this.minDate[1] > inpDate[1]) ||
                          (this.minDate[2] === inpDate[2] &&
                            this.minDate[1] === inpDate[1] &&
                            this.minDate[0] > inpDate[0])
                        ) {
                          this.classList.add("not-valid");
                          this.setCustomValidity(
                            "Das gewählte Datum ist zu niedrig."
                          );
                          datenotok = -1;
                        }
                      }
                      if (this.maxDate && datenotok === 0) {
                        if (
                          this.maxDate[2] < inpDate[2] ||
                          (this.maxDate[2] === inpDate[2] &&
                            this.maxDate[1] < inpDate[1]) ||
                          (this.maxDate[2] === inpDate[2] &&
                            this.maxDate[1] === inpDate[1] &&
                            this.maxDate[0] < inpDate[0])
                        ) {
                          this.classList.add("not-valid");
                          this.setCustomValidity(
                            "Das gewählte Datum ist zu hoch."
                          );
                          datenotok = 1;
                        }
                      }
                      if (datenotok === 0) {
                        this.classList.add("valid");
                        this.setCustomValidity("");
                      }
                    } else {
                      this.classList.add("not-valid");
                      this.setCustomValidity(
                        "Bitte geben sie das Datum im korrekten Format an: DD.MM.JJJJ"
                      );
                    }
                  }
                }
              });
            }

            /*inputNode.type = 'text';
                        inputNode.addEventListener('focus', function () {
                            this.type = 'date';
                        });
                        // TODO min with inDate and minAge
                        if(input.inDate){
                            inputNode.min = moment().add(input.inDate, 'd').format('YYYY-MM-DD');
                        } else if (input.minAge){
                            inputNode.max = moment().subtract(input.minAge, 'y').format('YYYY-MM-DD');
                        } else {
                            inputNode.min = input.minDate;
                            inputNode.max = input.maxDate;
                        }*/

            // -- input type tel
          } else if (input.type === "tel") {
            input.pattern = "[0-9+]{0,100}";
            inputNode.addEventListener("input", function () {
              if (this.validity.patternMismatch) {
                this.setCustomValidity("Bitte das Format beachten!");
              } else {
                this.setCustomValidity("");
              }
            });
            if (input.autooptin) {
              inputNode.addEventListener("change", (e) => {
                if (e.target.value.length > 0) {
                  for (let k = 0, len = optins.length; k < len; k++) {
                    optins[k].checked = true;
                  }
                } else {
                  for (let k = 0, len = optins.length; k < len; k++) {
                    optins[k].checked = false;
                  }
                }
              });
            }
            // -- input type iban
          } else if (input.type === "iban") {
            inputNode.type = "text"; // iban is no valid type
            inputNode.pattern = lng.get("regEx-iban");

            inputNode.addEventListener("input", function (e) {
              if (e.target.value.length < 3) {
                e.target.value = e.target.value.toUpperCase();
              }
              if (e.target.value.length >= 23) {
                e.target.value = e.target.value.substring(
                  0,
                  e.target.value.length - 1
                );
              }
            });

            // custom validation message
            inputNode.dataset.validationMessage = lng.get("form-invalid-iban");
            inputNode.addEventListener("input", function () {
              this.setCustomValidity("");
            });
            // -- input type email
          } else if (input.type === "email") {
            inputNode.type = "text";
            inputNode.addEventListener("input", function (e) {
              this.value = this.value.toLowerCase();
              const inp = this.value;

              let syntaxRegEx = new RegExp(
                "^[a-z0-9._%+-]+@[a-z0-9.-]+[.]{1}[a-z]{2,4}$"
              );
              // if not required, allow an empty string to be valid
              if (!input.required) {
                syntaxRegEx = new RegExp(
                  "^$|^[a-z0-9._%+-]+@[a-z0-9.-]+[.]{1}[a-z]{2,4}$"
                );
              }
              if (syntaxRegEx.test(inp)) {
                if (
                  new RegExp(
                    "^[a-z0-9._%+-]+@(mailinator.com" +
                      "|icloud.de" + // further unwanted endings can be added with: '|address.ending'+
                      +"|gmail.de" +
                      +"|mailinator.com" +
                      +"|trash-Mail.com" +
                      +"|wegwerfmail.de" +
                      +"|spoofmail.de" +
                      +"|discard.email" +
                      +"|mail1a.de" +
                      +"|10minutemail.com" +
                      +"|eyepaste.com" +
                      +"|fakemailgenerator.com" +
                      +"|squizzy.de" +
                      +"|byom.de" +
                      +"|emailgo.de" +
                      +"|mogelmail.de" +
                      +"|Mailinator.com" +
                      +"|Trash-Mail.com" +
                      +"|Wegwerfmail.de" +
                      +"|Spoofmail.de" +
                      +"|Discard.email" +
                      +"|Mail1a.de" +
                      +"|10minutemail.com" +
                      +"|Eyepaste.com" +
                      +"|Fakemailgenerator.com" +
                      +"|Squizzy.de" +
                      +"|Byom.de" +
                      +"|Emailgo.de" +
                      +"|Mogelmail.de" +
                      ")$"
                  ).test(inp)
                ) {
                  this.setCustomValidity(
                    "Bitte geben Sie eine E-Mail Adresse eines anderen Providers ein."
                  );
                } else {
                  this.setCustomValidity("");
                }
              } else {
                this.setCustomValidity(
                  "Bitte geben Sie eine korrekte E-Mail Adresse ein.(Keine Umlaute/Großbuchstaben)"
                );
              }
            });
            //inputNode.pattern = '[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$';

            //if contact email is activated, add value to meta data
            if (input.contact) {
              inputNode.addEventListener("change", (e) => {
                that.formData.meta.contact = e.target.value;
              });
              if (!input.required) that.contactmail = inputNode;
            }
            if (input.autooptin) {
              inputNode.addEventListener("change", (e) => {
                if (e.target.value.length > 0) {
                  let k = 0;
                  const len = optins.length;
                  for (; k < len; k++) {
                    optins[k].checked = true;
                  }
                }
              });
            }
          } else if (input.type === "text") {
            inputNode.addEventListener("input", function () {
              this.setCustomValidity("");
            });
          } else if (input.type === "") {
          }

          // optional
          if (input.label) inputNode.placeholder = input.label;

          if (input.required) inputNode.required = input.required;

          if (typeof input.min === "number") {
            inputNode.min = input.min;
          }

          if (typeof input.max === "number") inputNode.max = input.max;

          if (typeof input.minLength === "number")
            inputNode.minLength = input.minLength;

          if (typeof input.maxLength === "number") {
            inputNode.maxLength = input.maxLength;
            inputNode.addEventListener("input", (e) => {
              //max length is not properly supported in devices ...
              if (e.target.value.length >= e.target.maxLength) {
                e.target.value = e.target.value.slice(0, e.target.maxLength);
              }
            });
          }
          if (input.pattern) inputNode.pattern = input.pattern;

          if (isdate) {
            const inputdiv = document.createElement("div");
            inputdiv.classList.add("dateinputdiv");
            inputdiv.appendChild(inputNode);
            const delbutton = document.createElement("i");
            delbutton.in = inputNode;
            delbutton.innerHTML = "clear";
            delbutton.classList.add("material-icons");
            delbutton.classList.add("cleardate");
            delbutton.addEventListener("click", function () {
              this.in.icleared = true;
              this.in.cleared = true;
              this.in.fp.clear();
            });
            inputdiv.appendChild(delbutton);
            td.appendChild(inputdiv);
          } else {
            td.appendChild(inputNode);
          }
        }
      }

      tr.getData = function () {
        const result = {
          name: data.meta.name,
          data: [],
        };

        let inputs = td.children;
        inputs = Array.from(inputs);
        inputs.map((input) => {
          switch (input.tagName) {
            case "DIV":
              input = input.children[0]; // handle the date picker
              result.data.push({
                name: input.name,
                val: input.value,
              });
              break;
            case "INPUT":
            case "SELECT":
              result.data.push({
                name: input.name,
                val: input.type === "checkbox" ? input.checked : input.value,
              });
              break;
            case "I":
              break;
            default:
              console.error(
                "getData in defaultInput for tag " +
                  input.tagName +
                  " not implemented"
              );
          }
        });
        return result;
      };
    }

    function genTel(data) {
      const td = document.createElement("td");
      const div = document.createElement("div");
      const divmobile = document.createElement("div");
      const divfest = document.createElement("div");
      div.appendChild(divfest);
      div.appendChild(divmobile);
      td.appendChild(div);
      tr.appendChild(td);
      tr.getData = function () {
        const result = {
          name: data.meta.name,
          data: {},
          type: "tel",
        };
        const names = ["vwmobile", "mobiletel", "vwfest", "festtel"];
        for (let i = 0; i < 4; i++) {
          let item;
          if ((item = tr.querySelector(`input[name=${names[i]}]`)))
            result.data[names[i]] = item.value;
        }
        return result;
      };
      if (data.meta.vorwahl) {
        //Telefonnummernlänge vorwahl 3-6 tel 4-12; zusammen 7-18
        const vwmobile = document.createElement("input");
        vwmobile.type = "number";
        vwmobile.name = "vwmobile";
        vwmobile.classList.add("vw");
        vwmobile.placeholder = "Mobil/Vorwahl";
        var mobiletel = document.createElement("input");
        mobiletel.classList.add("tel");
        mobiletel.type = "number";
        mobiletel.name = "mobiletel";
        mobiletel.placeholder = "Mobil/Nummer";
        const vwfest = document.createElement("input");
        vwfest.classList.add("vw");
        vwfest.type = "number";
        vwfest.name = "vwfest";
        vwfest.placeholder = "Festnetz/Vorwahl";
        var festtel = document.createElement("input");
        festtel.classList.add("tel");
        festtel.type = "number";
        festtel.name = "festtel";
        festtel.placeholder = "Festnetz/Nummer";
        divfest.appendChild(vwfest);
        divfest.appendChild(festtel);
        divmobile.appendChild(vwmobile);
        divmobile.appendChild(mobiletel);
        vwmobile.vwfest = vwfest;
        mobiletel.vwfest = vwfest;
        festtel.vwfest = vwfest;
        vwfest.vwmobile = vwmobile;
        mobiletel.vwmobile = vwmobile;
        festtel.vwmobile = vwmobile;
        vwfest.festtel = festtel;
        vwmobile.festtel = festtel;
        mobiletel.festtel = festtel;
        vwfest.mobiletel = mobiletel;
        vwmobile.mobiletel = mobiletel;
        festtel.mobiletel = mobiletel;
        mobiletel.div = div;
        festtel.div = div;
        vwmobile.div = div;
        vwfest.div = div;
        if (data.meta.required) {
          mobiletel.req = true;
          festtel.req = true;
          vwfest.req = true;
          vwmobile.req = true;
          vwmobile.setCustomValidity(
            "Bitte tragen Sie eine Telefonnummer ein."
          );
          vwfest.setCustomValidity("Bitte tragen Sie eine Telefonnummer ein.");
          mobiletel.setCustomValidity(
            "Bitte tragen Sie eine Telefonnummer ein."
          );
          festtel.setCustomValidity("Bitte tragen Sie eine Telefonnummer ein.");
          div.classList.add("telreq");
        }
        if (data.meta.autooptin) {
          mobiletel.addEventListener("change", (e) => {
            if (
              e.target.value.length > 3 &&
              e.target.vwmobile.value.length > 2
            ) {
              let k = 0;
              const len = optins.length;
              for (; k < len; k++) {
                optins[k].checked = true;
              }
            }
          });
          vwmobile.addEventListener("change", (e) => {
            if (
              e.target.value.length > 2 &&
              e.target.mobiletel.value.length > 3
            ) {
              let k = 0;
              const len = optins.length;
              for (; k < len; k++) {
                optins[k].checked = true;
              }
            }
          });
          festtel.addEventListener("change", (e) => {
            if (e.target.value.length > 2 && e.target.vwfest.value.length > 2) {
              let k = 0;
              const len = optins.length;
              for (; k < len; k++) {
                optins[k].checked = true;
              }
            }
          });
          vwfest.addEventListener("change", (e) => {
            if (
              e.target.value.length > 2 &&
              e.target.festtel.value.length > 3
            ) {
              let k = 0;
              const len = optins.length;
              for (; k < len; k++) {
                optins[k].checked = true;
              }
            }
          });
        }

        const allowedMobileNumbers = [
          "01511",
          "01512",
          "01514",
          "01515",
          "01516",
          "01517",
          "0160",
          "0170",
          "0171",
          "0175",
          "01520",
          "01522",
          "01523",
          "01525",
          "0162",
          "0172",
          "0173",
          "0174",
          "01590",
          "0176",
          "01790",
          "1570",
          "01573",
          "01575",
          "01577",
          "01578",
          "0163",
          "0177",
          "0178",
        ];

        function allTextFieldsValid(vwfest, festtel, vwmobile, mobiletel) {
          return (
            (mobiletel.value.length > 3 &&
              vwmobile.value.length > 2 &&
              checkAllowedNumbersVWMobile(vwmobile, mobiletel) &&
              festtel.value === "" &&
              vwfest.value === "") ||
            (festtel.value.length > 2 &&
              vwfest.value.length > 2 &&
              checkAllowedNumbersVWFest(vwfest, festtel) &&
              mobiletel.value === "" &&
              vwmobile.value === "") ||
            (festtel.value.length > 2 &&
              vwfest.value.length > 2 &&
              checkAllowedNumbersVWFest(vwfest, festtel) &&
              mobiletel.value.length > 3 &&
              vwmobile.value.length > 2 &&
              checkAllowedNumbersVWMobile(vwmobile, mobiletel))
          );
        }

        function checkAllowedNumbersVWFest(vwfest, festtel) {
          if (!data.meta.mobileValidation) {
            return true;
          }

          if (vwfest.value === "" && festtel.value === "") {
            vwfest.setCustomValidity("");
            vwfest.div.classList.remove("telfalse");
            vwfest.div.classList.add("teltrue");

            festtel.setCustomValidity("");
            festtel.div.classList.remove("telfalse");
            festtel.div.classList.add("teltrue");
            return true;
          } else if (vwfest.value && vwfest.value.length > 2) {
            if (allowedMobileNumbers.indexOf(vwfest.value.toString()) !== -1) {
              vwfest.setCustomValidity(
                "Bei der Eingabe handelt es sich um keine valide Festnetznummer"
              );
              vwfest.div.classList.remove("teltrue");
              vwfest.div.classList.add("telfalse");
              return false;
            } else {
              vwfest.setCustomValidity("");
              vwfest.div.classList.remove("telfalse");
              vwfest.div.classList.add("teltrue");
              return true;
            }
          } else
            vwfest.setCustomValidity(
              "Bitte tragen Sie eine Telefonnummer mit der geforderten Mindestlänge (3+4) ein"
            );
        }

        function checkAllowedNumbersVWMobile(vwmobile, mobiletel) {
          if (!data.meta.mobileValidation) {
            return true;
          }

          if (vwmobile.value === "" && mobiletel.value === "") {
            vwmobile.setCustomValidity("");
            vwmobile.div.classList.remove("telfalse");
            vwmobile.div.classList.add("teltrue");

            mobiletel.setCustomValidity("");
            mobiletel.div.classList.remove("telfalse");
            mobiletel.div.classList.add("teltrue");
            return true;
          } else if (mobiletel.value && mobiletel.value.length > 2) {
            if (
              allowedMobileNumbers.indexOf(vwmobile.value.toString()) === -1
            ) {
              vwmobile.setCustomValidity(
                "Bitte eine valide Mobilfunknummer eintragen"
              );
              vwmobile.div.classList.remove("teltrue");
              vwmobile.classList.add("not-valid");
              vwmobile.div.classList.add("telfalse");
              return false;
            } else {
              vwmobile.setCustomValidity("");
              vwmobile.div.classList.remove("telfalse");
              vwmobile.div.classList.add("teltrue");
              return true;
            }
          } else {
            vwmobile.setCustomValidity(
              "Bitte tragen Sie eine Telefonnummer mit der geforderten Mindestlänge (3+4) ein"
            );
            return false;
          }
        }

        mobiletel.addEventListener("input", function () {
          if (this.value.length > 12) this.value = this.value.slice(0, 12);
          this.div.classList.remove("telreq");
          this.div.classList.remove("teltrue");
          this.div.classList.remove("telfalse");
          if (this.req) {
            if (
              allTextFieldsValid(this.vwfest, this.festtel, this.vwmobile, this)
            ) {
              this.setCustomValidity("");
              this.festtel.setCustomValidity("");
              this.vwfest.setCustomValidity("");
              this.vwmobile.setCustomValidity("");
              this.div.classList.add("teltrue");
            } else {
              if (this.value.length > 3) this.setCustomValidity("");
              else
                this.setCustomValidity(
                  "Bitte tragen Sie eine Telefonnummer mit der geforderten Mindestlänge (3+4) ein"
                );
              if (this.festtel.value.length > 2)
                this.festtel.setCustomValidity("");
              else
                this.festtel.setCustomValidity(
                  "Bitte tragen Sie eine Telefonnummer mit der geforderten Mindestlänge (3+3) ein"
                );
              if (this.vwfest.value.length > 2)
                this.vwfest.setCustomValidity("");
              else
                this.vwfest.setCustomValidity(
                  "Bitte tragen Sie eine Telefonnummer mit der geforderten Mindestlänge (3+3) ein"
                );
              if (this.vwmobile.value.length > 2)
                this.vwmobile.setCustomValidity("");
              else
                this.vwmobile.setCustomValidity(
                  "Bitte tragen Sie eine Telefonnummer mit der geforderten Mindestlänge (3+4) ein"
                );
              this.div.classList.add("telfalse");
              checkAllowedNumbersVWFest(vwfest, festtel);
              checkAllowedNumbersVWMobile(vwmobile, this);
            }
          } else {
            if (
              allTextFieldsValid(this.vwfest, this.festtel, this.vwmobile, this)
            ) {
              this.setCustomValidity("");
              this.festtel.setCustomValidity("");
              this.vwfest.setCustomValidity("");
              this.vwmobile.setCustomValidity("");
              this.div.classList.add("teltrue");
            } else {
              if (
                (this.value === "" && this.vwmobile.value === "") ||
                this.value.length > 3
              )
                this.setCustomValidity("");
              else
                this.setCustomValidity(
                  "Die Telefonnummer hat nicht die geforderte Mindestlänge (3+4)"
                );
              if (
                (this.festtel.value === "" && this.vwfest.value === "") ||
                this.festtel.value.length > 3
              )
                this.festtel.setCustomValidity("");
              else
                this.festtel.setCustomValidity(
                  "Die Telefonnummer hat nicht die geforderte Mindestlänge (3+3)"
                );
              if (
                (this.vwfest.value === "" && this.festtel.value === "") ||
                this.vwfest.value.length > 2
              )
                this.vwfest.setCustomValidity("");
              else
                this.vwfest.setCustomValidity(
                  "Die Telefonnummer hat nicht die geforderte Mindestlänge (3+3)"
                );
              if (
                (this.vwmobile.value === "" && this.value === "") ||
                this.vwmobile.value.length > 2
              )
                this.vwmobile.setCustomValidity("");
              else {
                this.vwmobile.setCustomValidity(
                  "Die Telefonnummer hat nicht die geforderte Mindestlänge (3+4)"
                );
              }
              this.div.classList.add("telfalse");
              checkAllowedNumbersVWFest(vwfest, festtel);
              checkAllowedNumbersVWMobile(vwmobile, this);
            }
          }
        });
        festtel.addEventListener("input", function () {
          if (this.value.length > 12) this.value = this.value.slice(0, 12);
          this.div.classList.remove("telreq");
          this.div.classList.remove("teltrue");
          this.div.classList.remove("telfalse");
          if (this.req) {
            if (
              allTextFieldsValid(
                this.vwfest,
                this,
                this.vwmobile,
                this.mobiletel
              )
            ) {
              this.mobiletel.setCustomValidity("");
              this.setCustomValidity("");
              this.vwfest.setCustomValidity("");
              this.vwmobile.setCustomValidity("");
              this.div.classList.add("teltrue");
            } else {
              if (this.mobiletel.value.length > 3)
                this.mobiletel.setCustomValidity("");
              else
                this.mobiletel.setCustomValidity(
                  "Bitte tragen Sie eine Telefonnummer mit der geforderten Mindestlänge (3+4) ein"
                );
              if (this.value.length > 2) this.setCustomValidity("");
              else
                this.setCustomValidity(
                  "Bitte tragen Sie eine Telefonnummer mit der geforderten Mindestlänge (3+4) ein"
                );
              if (this.vwfest.value.length > 2)
                this.vwfest.setCustomValidity("");
              else
                this.vwfest.setCustomValidity(
                  "Bitte tragen Sie eine Telefonnummer mit der geforderten Mindestlänge (3+4) ein"
                );
              if (this.vwmobile.value.length > 2)
                this.vwmobile.setCustomValidity("");
              else
                this.vwmobile.setCustomValidity(
                  "Bitte tragen Sie eine Telefonnummer mit der geforderten Mindestlänge (3+4) ein"
                );
              this.div.classList.add("telfalse");

              checkAllowedNumbersVWFest(vwfest, this);
              checkAllowedNumbersVWMobile(vwmobile, mobiletel);
            }
          } else {
            if (
              allTextFieldsValid(
                this.vwfest,
                this,
                this.vwmobile,
                this.mobiletel
              )
            ) {
              this.mobiletel.setCustomValidity("");
              this.setCustomValidity("");
              this.vwfest.setCustomValidity("");
              this.vwmobile.setCustomValidity("");
              this.div.classList.add("teltrue");
            } else {
              if (
                (this.value === "" && this.vwfest.value === "") ||
                this.value.length > 2
              )
                this.setCustomValidity("");
              else
                this.setCustomValidity(
                  "Die Telefonnummer hat nicht die geforderte Mindestlänge (3+3)"
                );
              if (
                (this.vwfest.value === "" && this.value === "") ||
                this.vwfest.value.length > 2
              )
                this.vwfest.setCustomValidity("");
              else
                this.vwfest.setCustomValidity(
                  "Die Telefonnummer hat nicht die geforderte Mindestlänge (3+3)"
                );
              if (
                (this.vwmobile.value === "" && this.mobiletel.value === "") ||
                this.vwmobile.value.length > 2
              )
                this.vwmobile.setCustomValidity("");
              else
                this.vwmobile.setCustomValidity(
                  "Die Telefonnummer hat nicht die geforderte Mindestlänge (3+4)"
                );
              if (
                (this.vwmobile.value === "" && this.mobiletel.value === "") ||
                this.mobiletel.value.length > 3
              )
                this.mobiletel.setCustomValidity("");
              else
                this.mobiletel.setCustomValidity(
                  "Die Telefonnummer hat nicht die geforderte Mindestlänge (3+4)"
                );
              this.div.classList.add("telfalse");

              checkAllowedNumbersVWFest(vwfest, this);
              checkAllowedNumbersVWMobile(vwmobile, mobiletel);
            }
          }
        });
        vwfest.addEventListener("input", function () {
          if (this.value.length > 6) this.value = this.value.slice(0, 6);
          this.div.classList.remove("telreq");
          this.div.classList.remove("teltrue");
          this.div.classList.remove("telfalse");
          if (this.req) {
            if (
              allTextFieldsValid(
                this,
                this.festtel,
                this.vwmobile,
                this.mobiletel
              )
            ) {
              this.mobiletel.setCustomValidity("");
              this.festtel.setCustomValidity("");
              this.setCustomValidity("");
              this.vwmobile.setCustomValidity("");
              this.div.classList.add("teltrue");
            } else {
              if (this.mobiletel.value.length > 3)
                this.mobiletel.setCustomValidity("");
              else
                this.mobiletel.setCustomValidity(
                  "Bitte tragen Sie eine Telefonnummer mit der geforderten Mindestlänge (3+4) ein"
                );
              if (this.festtel.value.length > 2)
                this.festtel.setCustomValidity("");
              else
                this.festtel.setCustomValidity(
                  "Bitte tragen Sie eine Telefonnummer mit der geforderten Mindestlänge (3+3) ein"
                );
              if (this.value.length > 2) this.setCustomValidity("");
              else
                this.setCustomValidity(
                  "Bitte tragen Sie eine Telefonnummer mit der geforderten Mindestlänge (3+3) ein"
                );
              if (this.vwmobile.value.length > 2)
                this.vwmobile.setCustomValidity("");
              else
                this.vwmobile.setCustomValidity(
                  "Bitte tragen Sie eine Telefonnummer mit der geforderten Mindestlänge (3+4) ein"
                );
              this.div.classList.add("telfalse");

              checkAllowedNumbersVWFest(this, festtel);
              checkAllowedNumbersVWMobile(vwmobile, mobiletel);
            }
          } else {
            if (
              allTextFieldsValid(
                this,
                this.festtel,
                this.vwmobile,
                this.mobiletel
              )
            ) {
              this.mobiletel.setCustomValidity("");
              this.festtel.setCustomValidity("");
              this.setCustomValidity("");
              this.vwmobile.setCustomValidity("");
              this.div.classList.add("teltrue");
            } else {
              if (
                (this.mobiletel.value === "" && this.vwmobile.value === "") ||
                this.mobiletel.value.length > 3
              )
                this.mobiletel.setCustomValidity("");
              else
                this.mobiletel.setCustomValidity(
                  "Die Telefonnummer hat nicht die geforderte Mindestlänge (3+4)"
                );
              if (
                (this.festtel.value === "" && this.value === "") ||
                this.festtel.value.length > 2
              )
                this.festtel.setCustomValidity("");
              else
                this.festtel.setCustomValidity(
                  "Die Telefonnummer hat nicht die geforderte Mindestlänge (3+3)"
                );
              if (
                (this.value === "" && this.festtel.value === "") ||
                this.value.length > 2
              )
                this.setCustomValidity("");
              else
                this.setCustomValidity(
                  "Die Telefonnummer hat nicht die geforderte Mindestlänge (3+3)"
                );
              if (
                (this.vwmobile.value === "" && this.mobiletel.value === "") ||
                this.vwmobile.value.length > 2
              )
                this.vwmobile.setCustomValidity("");
              else
                this.vwmobile.setCustomValidity(
                  "Die Telefonnummer hat nicht die geforderte Mindestlänge (3+4)"
                );
              this.div.classList.add("telfalse");

              checkAllowedNumbersVWFest(this, festtel);
              checkAllowedNumbersVWMobile(vwmobile, mobiletel);
            }
          }
        });
        vwmobile.addEventListener("input", function () {
          if (this.value.length > 6) this.value = this.value.slice(0, 6);
          this.div.classList.remove("telreq");
          this.div.classList.remove("teltrue");
          this.div.classList.remove("telfalse");
          if (this.req) {
            if (
              allTextFieldsValid(
                this.vwfest,
                this.festtel,
                this,
                this.mobiletel
              )
            ) {
              this.mobiletel.setCustomValidity("");
              this.festtel.setCustomValidity("");
              this.vwfest.setCustomValidity("");
              this.setCustomValidity("");
              this.div.classList.add("teltrue");
            } else {
              if (this.mobiletel.value.length > 3)
                this.mobiletel.setCustomValidity("");
              else
                this.mobiletel.setCustomValidity(
                  "Bitte tragen Sie eine Telefonnummer mit der geforderten Mindestlänge (3+4) ein"
                );
              if (this.festtel.value.length > 2)
                this.festtel.setCustomValidity("");
              else
                this.festtel.setCustomValidity(
                  "Bitte tragen Sie eine Telefonnummer mit der geforderten Mindestlänge (3+3) ein"
                );
              if (this.vwfest.value.length > 2)
                this.vwfest.setCustomValidity("");
              else
                this.vwfest.setCustomValidity(
                  "Bitte tragen Sie eine Telefonnummer mit der geforderten Mindestlänge (3+3) ein"
                );
              this.div.classList.add("telfalse");
              checkAllowedNumbersVWFest(vwfest, festtel);
              checkAllowedNumbersVWMobile(this, mobiletel);
            }
          } else {
            if (
              allTextFieldsValid(
                this.vwfest,
                this.festtel,
                this,
                this.mobiletel
              )
            ) {
              this.mobiletel.setCustomValidity("");
              this.festtel.setCustomValidity("");
              this.vwfest.setCustomValidity("");
              this.setCustomValidity("");
              this.div.classList.add("teltrue");
            } else {
              if (
                (this.value === "" && this.mobiletel.value === "") ||
                this.value.length > 2
              )
                this.setCustomValidity("");
              else
                this.setCustomValidity(
                  "Die Telefonnummer hat nicht die geforderte Mindestlänge (3+4)"
                );
              if (
                (this.festtel.value === "" && this.vwfest.value === "") ||
                this.festtel.value.length > 2
              )
                this.festtel.setCustomValidity("");
              else
                this.festtel.setCustomValidity(
                  "Die Telefonnummer hat nicht die geforderte Mindestlänge (3+3)"
                );
              if (
                (this.vwfest.value === "" && this.festtel.value === "") ||
                this.vwfest.value.length > 2
              )
                this.vwfest.setCustomValidity("");
              else
                this.vwfest.setCustomValidity(
                  "Die Telefonnummer hat nicht die geforderte Mindestlänge (3+3)"
                );
              if (
                (this.value === "" && this.mobiletel.value === "") ||
                this.mobiletel.value.length > 3
              )
                this.mobiletel.setCustomValidity("");
              else
                this.mobiletel.setCustomValidity(
                  "Die Telefonnummer hat nicht die geforderte Mindestlänge (3+4)"
                );
              this.div.classList.add("telfalse");

              checkAllowedNumbersVWFest(vwfest, festtel);
              checkAllowedNumbersVWMobile(this, mobiletel);
            }
          }
        });
      } else {
        var mobiletel = document.createElement("input");
        mobiletel.classList.add("tel");
        mobiletel.type = "number";
        mobiletel.name = "mobiletel";
        mobiletel.placeholder = "Mobil";
        var festtel = document.createElement("input");
        festtel.classList.add("tel");
        festtel.type = "number";
        festtel.name = "festtel";
        festtel.placeholder = "Festnetz";
        divmobile.appendChild(mobiletel);
        divfest.appendChild(festtel);
        festtel.mobiletel = mobiletel;
        mobiletel.festtel = festtel;
        mobiletel.div = div;
        festtel.div = div;
        if (data.meta.required) {
          mobiletel.req = true;
          festtel.req = true;
          mobiletel.setCustomValidity(
            "Bitte tragen Sie eine Telefonnummer ein."
          );
          festtel.setCustomValidity("Bitte tragen Sie eine Telefonnummer ein.");
          div.classList.add("telreq");
        }
        if (data.meta.autooptin) {
          mobiletel.addEventListener("change", (e) => {
            if (e.target.value.length > 4) {
              let k = 0;
              const len = optins.length;
              for (; k < len; k++) {
                optins[k].checked = true;
              }
            }
          });
          festtel.addEventListener("change", (e) => {
            if (e.target.value.length > 4) {
              let k = 0;
              const len = optins.length;
              for (; k < len; k++) {
                optins[k].checked = true;
              }
            }
          });
        }
        mobiletel.addEventListener("input", function () {
          if (this.value.length > 18) this.value = this.value.slice(0, 18);
          this.div.classList.remove("telreq");
          this.div.classList.remove("teltrue");
          this.div.classList.remove("telfalse");
          if (this.req) {
            if (
              (this.value.length > 4 && this.festtel.value === "") ||
              (this.festtel.value.length > 4 && this.value === "") ||
              (this.festtel.value.length > 4 && this.value.length > 4)
            ) {
              this.setCustomValidity("");
              this.festtel.setCustomValidity("");
              this.div.classList.add("teltrue");
            } else {
              if (this.value.length > 4) this.setCustomValidity("");
              else
                this.setCustomValidity(
                  "Bitte tragen Sie eine Telefonnummer mit der geforderten Mindestlänge (3) ein"
                );
              if (this.festtel.value.length > 4)
                this.festtel.setCustomValidity("");
              else
                this.festtel.setCustomValidity(
                  "Bitte tragen Sie eine Telefonnummer mit der geforderten Mindestlänge (3) ein"
                );
              this.div.classList.add("telfalse");
            }
          } else {
            if (
              (this.value === "" && this.festtel.value === "") ||
              (this.value.length > 4 && this.festtel.value === "") ||
              (this.festtel.value.length > 4 && this.value === "") ||
              (this.festtel.value.length > 4 && this.value.length > 4)
            ) {
              this.setCustomValidity("");
              this.festtel.setCustomValidity("");
              this.div.classList.add("teltrue");
            } else {
              if (this.value === "" || this.value.length > 4)
                this.setCustomValidity("");
              else
                this.setCustomValidity(
                  "Die Telefonnummer hat nicht die geforderte Mindestlänge (3)"
                );
              if (this.festtel.value === "" || this.festtel.value.length > 4)
                this.festtel.setCustomValidity("");
              else
                this.festtel.setCustomValidity(
                  "Die Telefonnummer hat nicht die geforderte Mindestlänge (3)"
                );
              this.div.classList.add("telfalse");
            }
          }
        });
        festtel.addEventListener("input", function () {
          if (this.value.length > 18) this.value = this.value.slice(0, 18);
          this.div.classList.remove("telreq");
          this.div.classList.remove("teltrue");
          this.div.classList.remove("telfalse");
          if (this.req) {
            if (
              (this.value.length > 4 && this.mobiletel.value === "") ||
              (this.mobiletel.value.length > 4 && this.value === "") ||
              (this.mobiletel.value.length > 4 && this.value.length > 4)
            ) {
              this.setCustomValidity("");
              this.mobiletel.setCustomValidity("");
              this.div.classList.add("teltrue");
            } else {
              if (this.value.length > 4) this.setCustomValidity("");
              else
                this.setCustomValidity(
                  "Bitte tragen Sie eine Telefonnummer mit der geforderten Mindestlänge (3) ein"
                );
              if (this.mobiletel.value.length > 4)
                this.mobiletel.setCustomValidity("");
              else
                this.mobiletel.setCustomValidity(
                  "Bitte tragen Sie eine Telefonnummer mit der geforderten Mindestlänge (3) ein"
                );
              this.div.classList.add("telfalse");
            }
          } else {
            if (
              (this.value === "" && this.mobiletel.value === "") ||
              (this.value.length > 4 && this.mobiletel.value === "") ||
              (this.mobiletel.value.length > 4 && this.value === "") ||
              (this.mobiletel.value.length > 4 && this.value.length > 4)
            ) {
              this.setCustomValidity("");
              this.mobiletel.setCustomValidity("");
              this.div.classList.add("teltrue");
            } else {
              if (this.value === "" || this.value.length > 4)
                this.setCustomValidity("");
              else
                this.setCustomValidity(
                  "Die Telefonnummer hat nicht die geforderte Mindestlänge (3)"
                );
              if (
                this.mobiletel.value === "" ||
                this.mobiletel.value.length > 4
              )
                this.mobiletel.setCustomValidity("");
              else
                this.mobiletel.setCustomValidity(
                  "Die Telefonnummer hat nicht die geforderte Mindestlänge (3)"
                );
              this.div.classList.add("telfalse");
            }
          }
        });
      }
    }

    function genTextArea(data) {
      const td = document.createElement("td");
      tr.appendChild(td);
      const textarea = document.createElement("textarea");
      textarea.rows = data.meta.height;
      textarea.required = data.meta.required;
      textarea.placeholder = data.meta.placeholder;
      textarea.addEventListener("input", function () {
        this.setCustomValidity("");
      });
      td.appendChild(textarea);
      tr.getData = function () {
        const result = {
          name: data.meta.name,
          val: "",
        };

        let inputs = td.children;
        inputs = Array.from(inputs);
        if (inputs[0]) {
          result.val = inputs[0].value;
        }
        return result;
      };
    }

    function genText(data) {
      const td = document.createElement("td");
      tr.appendChild(td);
      const splittext = data.data.text.split("</p>");
      // with checkbox
      if (
        !data.meta.smalltext ||
        splittext.length - 1 <= data.meta.textlength
      ) {
        if (data.meta.checkbox) {
          var div = document.createElement("div");
          div.innerHTML = `
                    <div class="text-container">
                        <div class="checkbox-wrapper">
                        <label>
                            <div class="checkbox-img"></div>
                        </label>
                        </div>
                        <div class="checkbox-text">${data.data.text}</div>
                    </div>`;

          var checkbox = document.createElement("input");
          checkbox.type = "checkbox";
          checkbox.name = data.meta.name;
          checkbox.required = data.meta.required;
          optins.push(checkbox);
          var checkboxWrapper = div.querySelector(".checkbox-wrapper > label");
          checkboxWrapper.insertAdjacentElement("afterbegin", checkbox);

          td.appendChild(div);

          //add event listener for validation
          var textContainer = div.querySelector(".text-container");
          checkbox.addEventListener("change", () => {
            textContainer.classList.remove("not-valid");
            checkbox.setCustomValidity("");
          });
        } else {
          // ... without
          td.insertAdjacentHTML(
            "beforeend",
            `
                    <div class="text-container">
                        <div class="text">${data.data.text}</div>
                    </div>
                    `
          );
        }
      } else {
        let smalltext = "";
        let z = 0;
        const lenz = splittext.length;
        for (; z < data.meta.textlength && z < lenz; z++) {
          smalltext += splittext[z] + "</p>";
        }
        if (data.meta.checkbox) {
          var div = document.createElement("div");
          div.innerHTML = `
                    <div class="text-container">
                        <div class="checkbox-wrapper">
                        <label>
                            <div class="checkbox-img"></div>
                        </label>
                        </div>
                        <div class="checkbox-text">${smalltext}</div><div class="linebreak"></div>
                        <div class="checkbox-text-expander">Mehr anzeigen...</div>
                    </div>
                    `;
          var expander = div.querySelector(".checkbox-text-expander");
          expander.textelem = div.querySelector(".checkbox-text");
          expander.smalltext = smalltext;
          expander.largetext = data.data.text;
          expander.addEventListener("click", function () {
            if (this.innerHTML === "Mehr anzeigen...") {
              this.innerHTML = "Weniger anzeigen";
              this.textelem.innerHTML = this.largetext;
            } else {
              this.innerHTML = "Mehr anzeigen...";
              this.textelem.innerHTML = this.smalltext;
            }
          });
          var checkbox = document.createElement("input");
          checkbox.type = "checkbox";
          checkbox.name = data.meta.name;
          checkbox.required = data.meta.required;
          optins.push(checkbox);
          var checkboxWrapper = div.querySelector(".checkbox-wrapper > label");
          checkboxWrapper.insertAdjacentElement("afterbegin", checkbox);

          td.appendChild(div);

          //add event listener for validation
          var textContainer = div.querySelector(".text-container");
          checkbox.addEventListener("change", () => {
            textContainer.classList.remove("not-valid");
          });
        } else {
          // ... without
          td.insertAdjacentHTML(
            "beforeend",
            `
                    <div class="text-container">
                        <div class="text">${smalltext}</div>
                        <div class="text-expander">Mehr anzeigen...</div>
                    </div>
                    `
          );
          var expander = td.querySelector(".text-expander");
          expander.textelem = td.querySelector(".text");
          expander.smalltext = smalltext;
          expander.largetext = data.data.text;
          expander.addEventListener("click", function () {
            if (this.innerHTML === "Mehr anzeigen...") {
              this.innerHTML = "Weniger anzeigen";
              this.textelem.innerHTML = this.largetext;
            } else {
              this.innerHTML = "Mehr anzeigen...";
              this.textelem.innerHTML = this.smalltext;
            }
          });
        }
      }

      if (data.meta.checkbox) {
        tr.getData = function () {
          const result = {
            name: data.meta.name,
            data: {},
          };
          result.data[checkbox.name] = checkbox.checked;
          return result;
        };
      }
    }

    function genSign(data) {
      const td = document.createElement("td");
      tr.appendChild(td);
      td.colSpan = 2;

      td.insertAdjacentHTML(
        "beforeend",
        `
                <div>
                <canvas></canvas>
                <div class="clear"><i class="material-icons">delete_forever</i></div>
                </div>
            `
      );

      //var debugTitle = td.querySelector('h5');
      const clearButton = td.querySelector(".clear");
      const canvas = td.querySelector("canvas");

      canvas.width = 550;
      canvas.height = 250;

      // add validation information
      canvas.dataset.SIGN_REQUIRED_LENGTH = SIGN_REQUIRED_LENGTH;

      canvas.path = [];
      if (data.meta.required) canvas.classList.add("required");

      const ctx = canvas.getContext("2d");
      let lastPoint = null;
      let rect;

      ctx.fillStyle = "#eeeeee";
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      clearButton.addEventListener("click", function (e) {
        canvas.clear();
      });

      // add clear function
      canvas.clear = function () {
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        lastPoint = null;
        canvas.path = [];
        if (data.meta.required) canvas.classList.add("required");
      };

      canvas.addEventListener("mousemove", drawSign, false);
      canvas.addEventListener("touchmove", drawSign, false);

      canvas.addEventListener("mouseleave", () => (lastPoint = null));
      canvas.addEventListener("mouseup", () => {
        lastPoint = null;
      });
      canvas.addEventListener("touchend", () => {
        lastPoint = null;
      });

      // Prevent scrolling when touching the canvas
      document.body.addEventListener(
        "touchstart",
        function (e) {
          if (e.target === canvas) {
            let el = document.querySelector(":focus");
            if (el) el.blur();
            e.preventDefault();
          }
        },
        { passive: false }
      );
      document.body.addEventListener(
        "touchend",
        function (e) {
          if (e.target === canvas) {
            e.preventDefault();
          }
        },
        { passive: false }
      );
      document.body.addEventListener(
        "touchmove",
        function (e) {
          if (e.target === canvas) {
            e.preventDefault();
          }
        },
        { passive: false }
      );

      function drawSign(e) {
        if (e.cancelable) {
          e.preventDefault();
        }

        let currentPoint;

        switch (e.type) {
          case "mousemove":
            if (e.buttons === 0)
              //cancel until desktop user does not push any button
              return;
            currentPoint = { x: e.offsetX, y: e.offsetY };
            break;
          case "touchmove":
            if (!lastPoint)
              //only update the rect on first touch event
              rect = canvas.getBoundingClientRect();
            const touch = e.touches[0];
            currentPoint = {
              x: parseInt(touch.clientX - rect.left, 10),
              y: parseInt(touch.clientY - rect.top, 10),
            };
            break;
        }

        if (!lastPoint) {
          ctx.beginPath();
          ctx.moveTo(currentPoint.x, currentPoint.y);
          ctx.stroke();
          canvas.path.push("x");
        } else {
          ctx.lineTo(currentPoint.x, currentPoint.y);
          ctx.stroke();
        }

        lastPoint = currentPoint;
        canvas.path.push(currentPoint.x + ":" + currentPoint.y);
        if (canvas.path.length >= SIGN_REQUIRED_LENGTH)
          canvas.classList.remove("not-valid");
      }

      tr.getData = function () {
        return {
          name: data.meta.name,
          data: {
            path: canvas.path.join(","), // (path)
          },
        };
      };
    }

    function genSubmit() {
      const td = document.createElement("td");
      tr.appendChild(td);
      // td.colSpan = 2;
      td.insertAdjacentHTML(
        "beforeend",
        `
                <button class="ok mdl-button mdl-js-button">${lng.get(
                  "form-submit"
                )}</button>
                <button class="blueprint mdl-button mdl-js-button">${lng.get(
                  "form-blueprint"
                )}</button>
                <button class="clear mdl-button mdl-js-button">${lng.get(
                  "form-clear"
                )}</button>
            `
      );

      const submitButton = td.querySelector("button.ok");
      const clearButton = td.querySelector("button.clear");
      const blueprintButton = td.querySelector("button.blueprint");

      // -- eventlistener for submit button
      submitButton.addEventListener("click", function (e) {
        if (validateForm(that)) {
          setTimeout(() => {
            const data = getJSON();
            that.onsubmit(data);
            that.clear();
          }, 750);
        }
      });
      // -- eventlistener for clear button
      clearButton.addEventListener("click", function (e) {
        that.clear();
      });
      // -- eventlistener for blueprint button
      blueprintButton.addEventListener("click", function (e) {
        if (validateForm(that)) {
          const data = that.getJSON();
          that.onChooseBlueprint(data);
        }
      });
    }
  }

  /**
   * Collects all data from all inputs via the getData method their according tr
   */
  function getJSON() {
    const result = [];

    const allInputs = that.node.querySelectorAll("tr.input");

    let i = 0;
    const len = allInputs.length;
    for (; i < len; i++) {
      const input = allInputs[i];
      if (typeof input.getData !== "function") continue;

      result.push(input.getData());
    }
    that.formData.data = result;
    return JSON.stringify(that.formData);
  }

  function clear() {
    that.formData = {
      meta: {},
      data: [],
    };

    const allFormElements = that.node.querySelectorAll("tr.input");

    let i = 0;
    const len = allFormElements.length;
    for (; i < len; i++) {
      const input = allFormElements[i];
      if (typeof input.resetElement !== "function") continue;

      input.resetElement(true);
    }

    // --- clear inputs
    const allInputs = that.node.querySelectorAll("input");
    if (that.contactmail) that.contactmail.required = false;
    for (let i = 0, len = allInputs.length; i < len; i++) {
      const input = allInputs[i];
      input.classList.remove("not-valid");
      switch (input.type) {
        case "text":
          const inputWrapper = closest(input, ".multichoice-elem");
          if (inputWrapper) {
            input.setCustomValidity("");
          }
        case "number":
        case "email":
        case "date":
        case "datetime":
        case "tel":
          if (
            input.classList.contains("tel") ||
            input.classList.contains("vw")
          ) {
            input.value = null;

            input.parentNode.parentNode.classList.remove("teltrue");
            input.parentNode.parentNode.classList.remove("telfalse");
            if (input.req) {
              input.parentNode.parentNode.classList.add("telreq");
              input.setCustomValidity(
                "Bitte tragen Sie eine Telefonnummer ein."
              );
            }
          }
          if (input.fp) {
            input.cleared = true;
            input.icleared = true;
            input.fp.clear();
            input.value = null;
          } else {
            input.value = null;
          }
          break;
        case "checkbox":
          if (input.req) {
            input.setCustomValidity("Bitte wählen Sie eines der Felder aus.");
          }
          if (
            input.parentElement.parentElement.parentElement.classList.contains(
              "hidden"
            )
          ) {
            input.parentElement.parentElement.parentElement.classList.remove(
              "hidden"
            );
            const checkboxes =
              input.parentElement.parentElement.parentElement.querySelectorAll(
                "input[type=checkbox]"
              );
            checkboxes[0].setCustomValidity(
              "Bitte wählen Sie eines der Felder aus."
            );
            checkboxes[1].setCustomValidity(
              "Bitte wählen Sie eines der Felder aus."
            );
          }
          input.checked = false;
          input.parentNode.parentNode.classList.remove("not-valid");
          input.parentNode.parentNode.parentNode.classList.remove("not-valid");
          input.classList.remove("valid");
          input.classList.remove("not-valid");

          if (
            input.parentElement.parentElement.parentElement.classList.contains(
              "multichoice-elem"
            )
          ) {
            input.parentElement.parentElement.parentElement.classList.remove(
              "not-valid"
            );
          }

          if (input.classList.contains("isRequired")) {
            input.setCustomValidity(lng.get("form-input-raffle-required"));
          }

          if (input.requiredmulti)
            input.setCustomValidity(
              "Bitte wählen Sie mindestens eines der Felder aus."
            );
          break;
        case "radio":
          input.checked = false;
          break;
        default:
          input.value = null;
          console.error(input.type + " not implemented");
      }
    }
    // --- clear textarea
    const allTextArea = that.node.querySelectorAll("textarea");
    for (let i = 0, len = allTextArea.length; i < len; i++) {
      const textarea = allTextArea[i];
      textarea.classList.remove("not-valid");
      textarea.value = null;
    }
    // --- clear selects
    const allSelects = that.node.querySelectorAll("select");
    for (let i = 0, len = allSelects.length; i < len; i++) {
      allSelects[i].selectedIndex = 0;
      allSelects[i].classList.remove("not-valid");
      allSelects[i].classList.remove("selectvalid");
      allSelects[i].classList.remove("selectinvalid");
      if (allSelects[i].emptySelect) {
        allSelects[i].classList.add("selectreqired");
        allSelects[i].setCustomValidity("Bitte wählen sie einen Wert aus.");
      }
    }

    // --- clear canvas
    const allCanvasContainer = that.node.querySelectorAll(
      ".input-sign div:not(.clear)"
    );
    for (let i = 0, len = allCanvasContainer.length; i < len; i++) {
      const canvas = allCanvasContainer[i].querySelector("canvas");
      canvas.classList.remove("not-valid");
      canvas.clear();
      // allCanvasContainer[i].querySelector("div.clear").click();
    }
  }

  function isDirty() {
    const allInputs = that.node.querySelectorAll("input");
    for (var i = 0, len = allInputs.length; i < len; i++) {
      const input = allInputs[i];
      switch (input.type) {
        case "text":
        case "number":
        case "email":
        case "date":
        case "datetime":
        case "tel":
          if (input.value) return true;
          break;
        case "checkbox":
          if (input.checked) return true;
          break;
        default:
          console.error(input.type + " not implemented");
      }
    }

    const allTextArea = that.node.querySelectorAll("textarea");
    for (var i = 0, len = allTextArea.length; i < len; i++)
      if (allTextArea[i].value) return true;

    const allSelects = that.node.querySelectorAll("select");
    for (var i = 0, len = allSelects.length; i < len; i++)
      if (allSelects[i].selectedIndex !== 0) return true;

    const allSigns = that.node.querySelectorAll(".input-sign canvas");
    for (var i = 0, len = allSigns.length; i < len; i++)
      if (allSigns[i].path.length > 0) return true;

    return false;
  }

  function loadData(data) {
    if (typeof data === "string") data = JSON.parse(data);

    let inputRows = that.node.querySelectorAll("tr.input");
    inputRows = Array.from(inputRows);

    inputRows.map((inputRow) => {
      const inputRowName = inputRow.data.name;

      let rowInputs = inputRow.querySelectorAll("input, select, textarea");
      rowInputs = Array.from(rowInputs);
      rowInputs.map((input) => {
        const key = [inputRowName, input.name];
        let userInput = getValueByKey(key, data.data);
        if (userInput === undefined) return;

        switch (input.tagName) {
          case "INPUT":
            switch (input.type) {
              case "text":
              case "email":
              case "number":
              case "date":
              case "tel":
              case "iban": // TODO: change this!!
                input.value = userInput;

                input.classList.remove("not-chosen");
                input.classList.remove("selectreqired");
                input.classList.remove("selectinvalid");
                input.classList.remove("selectvalid");

                if (userInput !== "") {
                  input.classList.add("selectvalid");
                  input.classList.add("valid");
                  input.setCustomValidity("");
                }

                break;
              case "checkbox":
                input.checked = !!userInput;
                break;
              default:
                console.warn(`Input type ${input.type} not implemented!`);
            }
            break;
          case "SELECT":
            //search option with value
            let option = input.querySelector(`[value="${userInput}"]`);

            if (!option || userInput === "") return;

            option.selected = true;

            input.classList.remove("not-chosen");
            input.classList.remove("selectreqired");
            input.classList.remove("selectinvalid");
            input.classList.remove("selectvalid");
            if (userInput !== "") {
              input.classList.add("selectvalid");
              input.classList.add("valid");
              input.setCustomValidity("");
            }

            option.selected = true;
            break;
          case "TEXTAREA":
            input.value = userInput;
            break;
        }
      });
    });

    /**
     * Get value from <i>Customer.data</i>
     * TODO copy this function with grunt to all projects (app and admin: formViewer.loadData(); server: CustomerService.csv())
     * @param {Array} key
     * @param {Array} data
     * @returns {undefined}
     */
    function getValueByKey(key, data) {
      let i = 0;
      const len = data.length;
      for (; i < len; i++) {
        const customerDataItem = data[i];

        /**
         * Allways avaiable
         * @type string
         */
        customerDataItem.name;

        /**
         * optional (if not, .data)
         * @type string|boolean
         */
        customerDataItem.val;

        /**
         * optional (if not, .val)
         * Array with object containing same structure like <i>customerDataItem</i>, except <i>val</i> is allways avaiable and never <i>data</i>.
         * On Arrays you do not have to check <i>customerDataItem.name</i>, because custom names are unique in the whole form.
         * Or Object where the keys are input names of inputs inside a div with attribute <i>.data.name === customerDataItem.name</i>
         * @type Array|Object
         */
        customerDataItem.data;

        if (customerDataItem.name !== key[0]) continue;

        if (customerDataItem.val !== undefined) return customerDataItem.val;

        if (!Array.isArray(customerDataItem.data)) {
          //for text inputs, the subitem has the same kay like the first level item
          return customerDataItem.data[key[1]] || customerDataItem.data[key[0]];
        }

        if (!key[1]) {
          console.warn(
            `Second key expected, but not found. key: ${key.join(".")}`
          );
          return;
        }

        const customerSubData = customerDataItem.data;
        let j = 0;
        const len2 = customerSubData.length;
        for (; j < len2; j++) {
          const customerSubDataItem = customerSubData[j];

          if (customerSubDataItem.name !== key[1]) continue;

          return customerSubDataItem.val;
        }
      }
    }
  }
}
